import { isEmpty } from '../../_helpers';

export const toMxcTemplate = {
  backend: (schema, version) => {
    if (version === '1.0') {
      const { applicationMpaId, mpaToFilesMap, selectedFiles, useMpaId } = schema || {};
      if (useMpaId) {
        return [
          {
            applicationMpaId,
            fileList: formatFileListBackend(selectedFiles)
          }
        ];
      }
      return !isEmpty(mpaToFilesMap)
        ? Object.values(mpaToFilesMap).map((mpaItem) => ({
            applicationMpaId: mpaItem.applicationMpaId,
            fileList: formatFileListBackend(mpaItem.selectedFiles)
          }))
        : [];
    }
    return [];
  }
};

const formatFileListBackend = (fileList) => {
  return fileList.reduce((acc, file) => {
    const { fileSelected, guidValue, name, selectedMxcTag } = file || {};
    return fileSelected
      ? acc.concat({
          resourceGuid: guidValue,
          fileName: name,
          mxcTag: selectedMxcTag.value
        })
      : acc;
  }, []);
};

export default toMxcTemplate;
